import React, { useEffect, useState, useContext, useCallback } from 'react';
import css from './ChoosePack.module.scss';
import T from '../../../../common/components/T';
import { getData } from '../../../../common/utils/router';
import UserContext from '../../../../common/utils/getContext';
import FormInput from '../../../../widgets/form/components/form-input/FormInput/FormInput';
import FormCheckbox from '../../../../widgets/form/components/form-checkbox/FormCheckbox/FormCheckbox';

const ChooseProduct = (props) => {
    const { userToken, lang } = useContext(UserContext);
    const { attribute, setFormData } = props;

    const [packItems, setPackItems] = useState([]);
    // const [dataArr, setDataArr] = useState([]);
    let dataArr = {};

    useEffect(() => {
        getData('/api/v1/admin/marketing/lists/packages', userToken, lang).then((data) => {
            if (data?.data) {
                const packArr = [];
                data.data.map((i) => {
                    packArr.push({
                        ...i,
                        quantity: '0',
                        recruiting_withdrawal: '0'
                    });
                });
                packArr.push({
                    id: 'upgrade',
                    marketing_package_id: 2,
                    from_marketing_package_id: 1,
                    title: <T textName='adminArrival-pack_upgrade' defaultStr='Апгрейд 50 на 100' page='all' />,
                    quantity: '0',
                    recruiting_withdrawal: '0'
                });
                setPackItems(packArr);
                packArr.map((i) => {
                    if (i.id == 'upgrade') {
                        dataArr.upgrade = {
                            marketing_package_id: 2,
                            from_marketing_package_id: 1,
                            recruiting_withdrawal: '0',
                            quantity: '0'
                        };
                    } else {
                        dataArr[`marketing_package_id-${i.id}`] = {
                            marketing_package_id: i.id,
                            recruiting_withdrawal: '0',
                            quantity: '0'
                        };
                    }
                });
                setFormData(attribute, Object.values(dataArr));
            }
        });
    }, [lang, userToken]);

    const setFunc = useCallback((attr, v) => {
        if (attr.includes('upgrade_package')) {
            dataArr.upgrade = {
                ...dataArr.upgrade,
                quantity: v
            };
        } else if (attr.includes('marketing_package_id')) {
            dataArr[attr] = {
                ...dataArr[attr],
                quantity: v
            };
        } else if (attr == 'recruting_id-upgrade') {
            dataArr.upgrade = {
                ...dataArr.upgrade,
                recruiting_withdrawal: v == 1 ? '1' : '0'
            };
        } else {
            dataArr[`marketing_package_id-${attr.split('-')[1]}`] = {
                ...dataArr[`marketing_package_id-${attr.split('-')[1]}`],
                recruiting_withdrawal: v == 1 ? '1' : '0'
            };
        }
        setFormData(attribute, Object.values(dataArr));
    }, []);

    return (
        <div className={css.packList}>
            {packItems
                ? packItems.map((i) => {
                      return (
                          <div key={i.id}>
                              {i.id == 'upgrade' ? (
                                  <FormInput
                                      attribute={`upgrade_package_id-1`}
                                      compStyle={{
                                          wrapper: { className: css.inputMb }
                                      }}
                                      typeField={'number'}
                                      setFormData={setFunc}
                                      title={{
                                          body: i.title
                                      }}
                                      value={i.quantity}
                                  />
                              ) : (
                                  <FormInput
                                      attribute={`marketing_package_id-${i.id}`}
                                      compStyle={{
                                          wrapper: { className: css.inputMb }
                                      }}
                                      typeField={'number'}
                                      setFormData={setFunc}
                                      title={{
                                          body: i.name
                                      }}
                                      value={i.quantity}
                                  />
                              )}
                              <div className={css.checkMb}>
                                  <FormCheckbox
                                      attribute={`recruting_id-${i.id}`}
                                      disabled={false}
                                      title={{
                                          body: (
                                              <T
                                                  textName='adminArrival-pack_upgrade_recruting'
                                                  defaultStr='Удержание Recruting'
                                                  page='all'
                                              />
                                          )
                                      }}
                                      value={'0'}
                                      setFormData={setFunc}
                                  />
                              </div>
                          </div>
                      );
                  })
                : null}
        </div>
    );
};

export default ChooseProduct;
